export default __webpack_public_path__ + "static/media/phone.f65d3f79.svg";